
const EmployeesListComponent = ({ employees, onEdit, loading, onToggle, onAccess }) => {
    
    return (
        <div className="admin-table-wrapper">
            <table className="admin-table">
                <thead>
                    <tr>
                        <th className="col-sr">Sr</th>
                        <th className="col-name">Name</th>
                        <th className="col-surname">Surname</th>
                        <th className="col-mobile">Mobile No</th>
                        <th>Email Id</th>
                        <th>Designation</th>
                        <th>Department</th>
                        <th className="col-access">Status</th>
                        <th className="col-access">Access</th>
                        <th className="col-actions">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan="10" className="text-center">
                                Loading employees...
                            </td>
                        </tr>
                    )}

                    {!loading && employees.length === 0 && (
                        <tr>
                            <td colSpan="10" className="text-center">
                                No Employees Found
                            </td>
                        </tr>
                    )}

                    {!loading && employees.map((emp, index) => (
                        <tr key={emp.id}>
                            <td className="col-sr">{index + 1}</td>
                            <td className="col-name">{emp.name}</td>
                            <td className="col-surname">{emp.surname}</td>
                            <td className="col-mobile">{emp.mobile}</td>
                            <td>{emp.email}</td>
                            <td>{emp.designationName}</td>
                            <td>{emp.departmentName}</td>
                            <td className="col-access">
                                <button className="admin-btn-small">{emp.active ? "Active" : "Inactive"}</button>
                            </td>
                            <td className="col-access">
                                <button className="admin-btn-small rounded-lg text-white bg-[#337AB7] cursor-pointer px-2 py-1"
                                onClick={() => onAccess(emp)}>Access</button>
                            </td>

                            <td className="col-actions">
                                <div className="admin-action-edit col-actions">
                                    <span
                                        className="act-1 cursor-pointer"
                                        onClick={() => onEdit(emp)}
                                    >
                                        Edit Details
                                    </span>
                                    {" / "}
                                    <span
                                        className="act-2 cursor-pointer col-status"
                                        onClick={() => onToggle(emp)}
                                    >
                                        {emp.active ? "Deactivate" : "Activate"}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EmployeesListComponent;